import React from 'react';

const LandingFocusAreas = () => {
  const focusAreas = [
    {
      icon: "📚",
      title: "Education and Awareness",
      description: "We provide community education programs that promote knowledge, rights awareness, and informed decision-making."
    },
    {
      icon: "🧠",
      title: "Mental Health Awareness",
      description: "Our initiatives aim to raise awareness about mental health, reduce stigma, and promote access to support services."
    },
    {
      icon: "🛡️",
      title: "Prevention of Gender-Based Violence",
      description: "CAEI advocates for the prevention of violence against women and men by raising awareness, supporting victims, and promoting gender equality."
    },
    {
      icon: "🌱",
      title: "Empowering Adolescents Through Education",
      description: "We support adolescents through mentorship, educational support, and life-skills training to help them build brighter futures."
    },
    {
      icon: "🚀",
      title: "Youth Empowerment",
      description: "Our youth programs focus on leadership development, entrepreneurship, and skills training for young people."
    },
    {
      icon: "💪",
      title: "Capacity Building",
      description: "We strengthen individuals, community groups, and organizations through training and knowledge-sharing initiatives."
    }
  ];

  return (
    <section className="landing-focus-areas" id="focus-areas">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Focus Areas</h2>
          <p className="section-subtitle">Key areas where we create lasting impact</p>
        </div>
        <div className="focus-grid">
          {focusAreas.map((area, index) => (
            <div className="focus-card" key={index}>
              <div className="focus-icon">{area.icon}</div>
              <h3>{area.title}</h3>
              <p>{area.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LandingFocusAreas;
